import { eDmEmailConfigDefine } from "../../action-types/email/IDmEmailConfigActionTypes";
import { generateActions } from "../generateActions";

export const dmEmailConfigAction = {
    ...generateActions(eDmEmailConfigDefine, "EMAIL_CONFIG")
}